import React from 'react'
import PropTypes from 'prop-types'

import { Image, Text } from 'Components/UI'

import get from 'lodash/get'

import { Container, ImageHolder } from './styles'

function Participant({ data }) {
  const [firstName, lastName] = data?.fullName.split(' ')
  const lastNameLetter = get(lastName, [0])
  return (
    <Container>
      <ImageHolder>
        <Image
          alt={data.fullName}
          height={144}
          image={data?.image.src}
          lazy
          width={144}
        />
      </ImageHolder>
      <Text as="h3" mt={24}>
        {firstName} {lastNameLetter && `${lastNameLetter}.`}
      </Text>
    </Container>
  )
}

Participant.defaultProps = {
  data: {},
}

Participant.propTypes = {
  data: PropTypes.object,
}

export default Participant
